/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailPayments_viewer$ref: FragmentReference;
export type PdpSharedDetailPayments_viewer = {|
  +affirmEnabled: ?boolean,
  +regionalInfo: ?$ReadOnlyArray<?{|
    +countryCode: ?string
  |}>,
  +$refType: PdpSharedDetailPayments_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailPayments_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "affirmEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "AFFIRM",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"AFFIRM\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "regionalInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "countryCode",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '334901cf51da8cf065254fbdf052ad03';
module.exports = node;
